import { render, staticRenderFns } from "./PlaylistsView.vue?vue&type=template&id=dd1140ec"
import script from "./PlaylistsView.vue?vue&type=script&lang=js"
export * from "./PlaylistsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports